import { PassengerStatisticsComponent } from './features/passenger-statistics/passenger-statistics.component';
import { ManageTaxiAttendantsComponent } from './features/manage-taxi-attendants/manage-taxi-attendants.component';
import { EditTaxiAttendantComponent } from './features/manage-taxi-attendants/edit-taxi-attendant/edit-taxi-attendant.component';
import { LiveMapComponent } from './features/live-map/live-map.component';
import { ProfileComponent } from './features/profile/profile.component';
import { EditTaxiTripTourComponent } from './features/manage-taxi-trip-tour/edit-taxi-trip-tour/edit-taxi-trip-tour.component';
import { EditContactComponent } from './features/manage-stored-addresses/edit-contact/edit-contact.component';
import { StartpageComponent } from './features/startpage/startpage.component';
import { EditTripComponent } from './features/manage-trip/edit-trip/edit-trip.component';
import { ManageTripComponent } from './features/manage-trip/manage-trip.component';
import { RequestLicenseComponent } from './features/request-license/request-license.component';
import { EditTaxiDriverComponent } from './features/manage-taxi-driver/edit-taxi-driver/edit-taxi-driver.component';
import { ManageTaxiDriverComponent } from './features/manage-taxi-driver/manage-taxi-driver.component';
import { ManageTaxiCenterComponent } from './features/manage-taxi-center/manage-taxi-center.component';
import { ManageBusComponent } from './features/manage-bus/manage-bus.component';
import { HomeComponent } from './features/home/home.component';
import { Routes } from '@angular/router';
import { ManageTourPatternsComponent } from './features/manage-tour-patterns/manage-tour-patterns.component';
import { EditTourPatternComponent } from './features/manage-tour-patterns/edit-tour-pattern/edit-tour-pattern.component';
import { canActivateAuthRole } from './core/guards/keycloak-auth.guard';
import { licenseGuard } from './core/guards/license.guard';
import { appAccountGuard } from './core/guards/app-account.guard';
import { environment } from '../environments/environment';
import { DevComponent } from './features/dev/dev.component';
import { SidebarLayoutComponent } from './shared/layouts/sidebar-layout/sidebar-layout.component';
import { NotFoundPageComponent } from './shared/not-found-page/not-found-page.component';
import { BackendOfflineComponent } from './shared/components/backend-offline/backend-offline.component';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./features/startpage/startpage.component').then(
        (m) => m.StartpageComponent,
      ),
  },
  {
    path: 'noLicense',
    canActivate: [appAccountGuard],
    loadComponent: () =>
      import('./features/no-lincense/no-lincense.component').then(
        (m) => m.NoLincenseComponent,
      ),
  },
  {
    path: 'requestLicense',
    loadComponent: () =>
      import('./features/request-license/request-license.component').then(
        (m) => m.RequestLicenseComponent,
      ),
  },
  {
    path: 'createAccount',

    loadComponent: () =>
      import('./features/create-user-account/create-user-account.component').then(
        (m) => m.CreateUserAccountComponent,
      ),
  },
  {
    path: '',
    component: SidebarLayoutComponent,

    children: [
      {
        path: 'home',
        canActivate: [canActivateAuthRole, licenseGuard],
        loadComponent: () =>
          import('./features/home/home.component').then((m) => m.HomeComponent),
      },
      {
        path: 'bus',
        canActivate: [canActivateAuthRole, licenseGuard],

        loadComponent: () =>
          import('./features/manage-bus/manage-bus.component').then(
            (m) => m.ManageBusComponent,
          ),
      },
      {
        path: 'bus/editBus',
        canActivate: [canActivateAuthRole, licenseGuard],

        loadComponent: () =>
          import('./features/manage-bus/edit-bus/edit-bus.component').then(
            (m) => m.EditBusComponent,
          ),
      },
      {
        path: 'bus/editBus/:id',
        canActivate: [canActivateAuthRole, licenseGuard],

        loadComponent: () =>
          import('./features/manage-bus/edit-bus/edit-bus.component').then(
            (m) => m.EditBusComponent,
          ),
      },
      {
        path: 'bus/generateQrCode/:id',
        canActivate: [canActivateAuthRole, licenseGuard],

        loadComponent: () =>
          import('./features/manage-bus/generate-qr-code/generate-qr-code.component').then(
            (m) => m.GenerateQrCodeComponent,
          ),
      },
      {
        path: 'taxiCenter',
        canActivate: [canActivateAuthRole, licenseGuard],

        loadComponent: () =>
          import('./features/manage-taxi-center/manage-taxi-center.component').then(
            (m) => m.ManageTaxiCenterComponent,
          ),
      },
      {
        path: 'taxiCenter/editTaxiCenter',
        canActivate: [canActivateAuthRole, licenseGuard],
        loadComponent: () =>
          import('./features/manage-taxi-center/edit-taxi-center/edit-taxi-center.component').then(
            (m) => m.EditTaxiCenterComponent,
          ),
      },
      {
        path: 'taxiCenter/editTaxiCenter/:id',
        canActivate: [canActivateAuthRole, licenseGuard],

        loadComponent: () =>
          import('./features/manage-taxi-center/edit-taxi-center/edit-taxi-center.component').then(
            (m) => m.EditTaxiCenterComponent,
          ),
      },
      {
        path: 'taxiDriver',
        canActivate: [canActivateAuthRole, licenseGuard],

        loadComponent: () =>
          import('./features/manage-taxi-driver/manage-taxi-driver.component').then(
            (m) => m.ManageTaxiDriverComponent,
          ),
      },
      {
        path: 'taxiDriver/editTaxiDriver',
        canActivate: [canActivateAuthRole, licenseGuard],

        loadComponent: () =>
          import('./features/manage-taxi-driver/edit-taxi-driver/edit-taxi-driver.component').then(
            (m) => m.EditTaxiDriverComponent,
          ),
      },
      {
        path: 'taxiDriver/editTaxiDriver/:id',
        canActivate: [canActivateAuthRole, licenseGuard],

        loadComponent: () =>
          import('./features/manage-taxi-driver/edit-taxi-driver/edit-taxi-driver.component').then(
            (m) => m.EditTaxiDriverComponent,
          ),
      },
      {
        path: 'passenger',
        canActivate: [canActivateAuthRole, licenseGuard],

        loadComponent: () =>
          import('./features/manage-passenger/manage-passenger.component').then(
            (m) => m.ManagePassengerComponent,
          ),
      },
      {
        path: 'passenger/editPassenger',
        canActivate: [canActivateAuthRole, licenseGuard],

        loadComponent: () =>
          import('./features/manage-passenger/edit-passenger/edit-passenger.component').then(
            (m) => m.EditPassengerComponent,
          ),
      },
      {
        path: 'passenger/editPassenger/:id',
        canActivate: [canActivateAuthRole, licenseGuard],

        loadComponent: () =>
          import('./features/manage-passenger/edit-passenger/edit-passenger.component').then(
            (m) => m.EditPassengerComponent,
          ),
      },
      {
        path: 'passenger/calendar',
        canActivate: [canActivateAuthRole, licenseGuard],

        loadComponent: () =>
          import('./features/manage-passenger/passenger-calendar/passenger-calendar.component').then(
            (m) => m.PassengerCalendarComponent,
          ),
      },
      {
        path: 'trip',
        canActivate: [canActivateAuthRole, licenseGuard],

        loadComponent: () =>
          import('./features/manage-trip/manage-trip.component').then(
            (m) => m.ManageTripComponent,
          ),
      },
      {
        path: 'trip/search/:search',
        canActivate: [canActivateAuthRole, licenseGuard],

        loadComponent: () =>
          import('./features/manage-trip/manage-trip.component').then(
            (m) => m.ManageTripComponent,
          ),
      },
      {
        path: 'trip/addTrip',
        canActivate: [canActivateAuthRole, licenseGuard],

        loadComponent: () =>
          import('./features/manage-trip/edit-trip/edit-trip.component').then(
            (m) => m.EditTripComponent,
          ),
      },
      {
        path: 'contacts',
        canActivate: [canActivateAuthRole, licenseGuard],

        loadComponent: () =>
          import('./features/manage-stored-addresses/manage-stored-addresses.component').then(
            (m) => m.ManageStoredAddressesComponent,
          ),
      },
      {
        path: 'contacts/editContact',
        canActivate: [canActivateAuthRole, licenseGuard],

        loadComponent: () =>
          import('./features/manage-stored-addresses/edit-contact/edit-contact.component').then(
            (m) => m.EditContactComponent,
          ),
      },
      {
        path: 'contacts/editContact/:id',
        canActivate: [canActivateAuthRole, licenseGuard],

        loadComponent: () =>
          import('./features/manage-stored-addresses/edit-contact/edit-contact.component').then(
            (m) => m.EditContactComponent,
          ),
      },
      {
        path: 'triptour',
        canActivate: [canActivateAuthRole, licenseGuard],

        loadComponent: () =>
          import('./features/manage-taxi-trip-tour/manage-taxi-trip-tour.component').then(
            (m) => m.ManageTaxiTripTourComponent,
          ),
      },
      {
        path: 'triptour/editTaxiTripTour/:id',
        canActivate: [canActivateAuthRole, licenseGuard],

        loadComponent: () =>
          import('./features/manage-taxi-trip-tour/edit-taxi-trip-tour/edit-taxi-trip-tour.component').then(
            (m) => m.EditTaxiTripTourComponent,
          ),
      },
      {
        path: 'triptour/editTaxiTripTour/:id/changelog',
        canActivate: [canActivateAuthRole, licenseGuard],

        loadComponent: () =>
          import('./features/manage-taxi-trip-tour/taxi-trip-tour-changelog/taxi-trip-tour-changelog.component').then(
            (m) => m.TaxiTripTourChangelogComponent,
          ),
      },
      {
        path: 'profile',
        canActivate: [canActivateAuthRole, licenseGuard],

        loadComponent: () =>
          import('./features/profile/profile.component').then(
            (m) => m.ProfileComponent,
          ),
      },
      {
        path: 'appAccounts',
        canActivate: [canActivateAuthRole, licenseGuard],

        loadComponent: () =>
          import('./features/manage-app-account/manage-app-account.component').then(
            (m) => m.ManageAppAccountComponent,
          ),
      },
      {
        path: 'appAccounts/editAppAccount',
        canActivate: [canActivateAuthRole, licenseGuard],

        loadComponent: () =>
          import('./features/manage-app-account/edit-app-account/edit-app-account.component').then(
            (m) => m.EditAppAccountComponent,
          ),
      },
      {
        path: 'appAccounts/editAppAccount/:id',
        canActivate: [canActivateAuthRole, licenseGuard],

        loadComponent: () =>
          import('./features/manage-app-account/edit-app-account/edit-app-account.component').then(
            (m) => m.EditAppAccountComponent,
          ),
      },
      {
        path: 'live-map',
        canActivate: [canActivateAuthRole, licenseGuard],

        loadComponent: () =>
          import('./features/live-map/live-map.component').then(
            (m) => m.LiveMapComponent,
          ),
      },
      {
        path: 'driverStats',
        canActivate: [canActivateAuthRole, licenseGuard],

        loadComponent: () =>
          import('./features/driver-statistics/driver-statistics.component').then(
            (m) => m.DriverStatisticsComponent,
          ),
      },
      {
        path: 'passengerStats',
        canActivate: [canActivateAuthRole, licenseGuard],

        loadComponent: () =>
          import('./features/passenger-statistics/passenger-statistics.component').then(
            (m) => m.PassengerStatisticsComponent,
          ),
      },
      {
        path: 'trip/deviation/:tripId',
        canActivate: [canActivateAuthRole, licenseGuard],

        loadComponent: () =>
          import('./features/manage-trip/manage-deviation/manage-deviation.component').then(
            (m) => m.ManageDeviationComponent,
          ),
      },
      {
        path: 'trip/deviation/addDeviation/:tripId',
        canActivate: [canActivateAuthRole, licenseGuard],

        loadComponent: () =>
          import('./features/manage-trip/create-deviation/create-deviation.component').then(
            (m) => m.CreateDeviationComponent,
          ),
      },
      {
        path: 'bus/manageTimeouts/:busId',
        canActivate: [canActivateAuthRole, licenseGuard],

        loadComponent: () =>
          import('./features/manage-bus/manage-bus-timeout/manage-bus-timeout.component').then(
            (m) => m.ManageBusTimeoutComponent,
          ),
      },
      {
        path: 'bus/manageTimeouts/addTimeout/:busId',
        canActivate: [canActivateAuthRole, licenseGuard],

        loadComponent: () =>
          import('./features/manage-bus/add-bus-timeout/add-bus-timeout.component').then(
            (m) => m.AddBusTimeoutComponent,
          ),
      },
      {
        path: 'taxiAttendant/addTaxiAttendant',
        canActivate: [canActivateAuthRole, licenseGuard],

        loadComponent: () =>
          import('./features/manage-taxi-attendants/edit-taxi-attendant/edit-taxi-attendant.component').then(
            (m) => m.EditTaxiAttendantComponent,
          ),
      },
      {
        path: 'taxiAttendant/editTaxiAttendant/:id',
        canActivate: [canActivateAuthRole, licenseGuard],

        loadComponent: () =>
          import('./features/manage-taxi-attendants/edit-taxi-attendant/edit-taxi-attendant.component').then(
            (m) => m.EditTaxiAttendantComponent,
          ),
      },
      {
        path: 'taxiAttendant',
        canActivate: [canActivateAuthRole, licenseGuard],

        loadComponent: () =>
          import('./features/manage-taxi-attendants/manage-taxi-attendants.component').then(
            (m) => m.ManageTaxiAttendantsComponent,
          ),
      },
      {
        path: 'attendantStats',
        canActivate: [canActivateAuthRole, licenseGuard],

        loadComponent: () =>
          import('./features/attendant-statistics/attendant-statistics.component').then(
            (m) => m.AttendantStatisticsComponent,
          ),
      },
      {
        path: 'triptours/bulk-day-solve',
        canActivate: [canActivateAuthRole, licenseGuard],

        loadComponent: () =>
          import('./features/manage-trip/reassign-trips-to-tour/reassign-trips-to-tour.component').then(
            (m) => m.ReassignTripsToTourComponent,
          ),
      },
      {
        path: 'triptour/tourPatterns',
        canActivate: [canActivateAuthRole, licenseGuard],

        loadComponent: () =>
          import('./features/manage-tour-patterns/manage-tour-patterns.component').then(
            (m) => m.ManageTourPatternsComponent,
          ),
      },
      {
        path: 'triptour/tourPatterns/editTourPattern/:id',
        canActivate: [canActivateAuthRole, licenseGuard],

        loadComponent: () =>
          import('./features/manage-tour-patterns/edit-tour-pattern/edit-tour-pattern.component').then(
            (m) => m.EditTourPatternComponent,
          ),
      },
    ],
  },
  {
    component: BackendOfflineComponent,
    path: 'backend-offline',
  },
  {
    component: NotFoundPageComponent,
    path: '**',
  },
];

if (!environment.production) {
  routes.unshift({ path: 'dev', component: DevComponent });
}
